import { call, put, takeLatest } from 'redux-saga/effects';

import { PolicyCommissionInvoiceApi } from '@apis/PolicyCommissionInvoiceApi';
import { PolicyCommissionInvoice } from '@models/PolicyCommissionInvoice';
import { SagaPayload } from '@utils/typescript';

import {
  policyCommissionInvoiceFetch,
  PolicyCommissionInvoiceFetchPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';

function* handlePolicyCommissionInvoiceFetchFetch({ payload }: SagaPayload<PolicyCommissionInvoiceFetchPayload>) {
  const state: StateUpdatePayload = { invoice: null };
  try {
    state.invoice = (yield call(PolicyCommissionInvoiceApi.get, payload)) as PolicyCommissionInvoice;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(policyCommissionInvoiceFetch, handlePolicyCommissionInvoiceFetchFetch);
}
